import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginPage, VerifiedRoute, useAuth } from '@micronet/auth';
import { loadMe } from './lib/me';

// The whole authenticated app is downloaded only once VerifiedRoute confirms the
// session: an unauthenticated load carries the login page and nothing more.
const LazyShell = lazy(() => import('./Shell.tsx'));

export function FullPageLoading() {
  return <div className="flex h-screen items-center justify-center">Cargando…</div>;
}

// "/" — sign in. Once MSAL reports a session, go to the app; /home re-verifies
// with core, so this redirect is UX, not a boundary.
export function LoginRoute() {
  const { isAuthenticated, isLoading, error, signIn } = useAuth();
  if (isAuthenticated) return <Navigate to="/home" replace />;
  return (
    <LoginPage
      onSignIn={signIn}
      isSigningIn={isLoading}
      error={error}
      backgroundSrc="/micronet-login-background.svg"
      logoSrc="/micronet-logo.svg"
    />
  );
}

// "/home/*" — the boundary: the app renders only for an identity core resolves
// to an active user.
export function HomeRoute() {
  const { isAuthenticated, getAccessToken, signOut } = useAuth();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return (
    <VerifiedRoute
      verify={async () => (await loadMe(getAccessToken)) !== null}
      loading={<FullPageLoading />}
      onRejected={() => void signOut()}
    >
      <Suspense fallback={<FullPageLoading />}>
        <LazyShell />
      </Suspense>
    </VerifiedRoute>
  );
}
